//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  label: "home_page",
  data() {
    return {
      swiper_list: [
        {
          url: "javascript:",
          img: "static/img/banner1.jpg",
          title: ""
        },
        {
          url: "javascript:",
          img: "static/img/banner2.jpg",
          title: ""
        },
        {
          url: "javascript:",
          img: "static/img/banner3.jpg",
          title: ""
        },
        {
          url: "javascript:",
          img: "static/img/banner4.jpg",
          title: ""
        }
      ],
      form_enter: [
        {
          path: "home_page_next",
          label: "数据库",
          form: "",
          type: "1",
          img: "static/img/db.png"
        },
        {
          path: "home_page_next",
          label: "数据结构",
          form: "",
          type: "2",
          img: "static/img/db_structure.png"
        },
        // {
        //   path: "send_notice",
        //   label: "通知",
        //   form: "",
        //   type: "",
        //   img: "static/img/send_notice.png"
        // },
        // {
        //   path: "qrcode",
        //   label: "二维码",
        //   form: "",
        //   type: "",
        //   img: "static/img/qrcode.png"
        // },
        // {
        //   path: "test",
        //   label: "测试",
        //   form: "",
        //   type: "",
        //   img: "static/img/hat.png"
        // },
        // {
        //   path: "stu_up_question",
        //   label: "答疑",
        //   form: "",
        //   type: "1",
        //   img: "static/img/dayi.png"
        // },
        // {
        //   path: "list",
        //   label: "技术",
        //   form: "course_learn_self",
        //   type: "",
        //   img: "static/img/read_book.png"
        // },
        // {
        //   path: "music",
        //   label: "音乐",
        //   form: "",
        //   type: "",
        //   img: "static/img/music.png"
        // }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("titleAction", "IT微课堂");
    localStorage.setItem("wkt_domain_name", "http://jd.littlewindy.com/");
  },
  methods: {
    enter_path(item) {
      //页面跳转
      let obj = {
        form: item.form,
        type: item.type
      };
      this.$router.push({
        path: item.path,
        query: obj
      });
    }
  },
  components: {}
};



// WEBPACK FOOTER //
// ./src/components/home_page.vue